// extracted by mini-css-extract-plugin
module.exports = {"bulkActions":"bulkActions__0Y+AD","text":"text__YeGbj","inputs":"inputs__Hoh-h","input":"input__MhvNw","buttons":"buttons__-9qTO"};